import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
// 繁体字フォント Noto Sans TC を自前同梱（可変フォント・必要なグリフのみ読込）。
// 外部 CDN へ通信せず、社内ネットワーク制限下でも確実に表示される。
import "@fontsource-variable/noto-sans-tc";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
